<section class="container">
  <h2 class="section-title">CSV インポート</h2>
  <p class="description">
    BIZTEL 管理画面のアカウント一覧 CSV
    をエクスポートし、連携したいユーザーの行だけ残してアップロードします。「メール」列と「ID」列は標準のエクスポートに含まれるため、列の表示設定は不要です。この
    2 列があれば他の列は無視されます。「ID」が空の行はエラーになります。CSV
    の内容で連携対象ユーザーの設定を全置換します。アップロード後に人数の増減とスキップされる行を確認してから実行できます。フォーマット不正や重複がある場合は取り込みを中止して現在の設定は変更されません。
  </p>

  <div class="upload">
    <label class="upload-button">
      <input
        type="file"
        accept=".csv,text/csv"
        (change)="this.onFileSelected($event)"
        [disabled]="this.isImporting"
      />
      <span>CSV を選択してアップロード</span>
    </label>
    @if (this.isImporting) {
      <span class="importing">アップロード中…</span>
    }
  </div>

  @if (this.importResult && this.isRejected) {
    <div class="result rejected" aria-live="polite">
      <h3 class="result-title">取り込みを中止しました</h3>
      <p class="rejected-note">
        CSV にエラーがあるため取り込みを中止しました。現在の連携対象ユーザーは
        変更されていません。以下のエラーを修正して再度アップロードしてください。
      </p>
      <table
        mat-table
        [dataSource]="this.importResult.errors"
        class="error-table"
      >
        <ng-container matColumnDef="row">
          <th mat-header-cell *matHeaderCellDef>行</th>
          <td mat-cell *matCellDef="let row">
            {{ this.formatErrorRow(row.row) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef>エラー内容</th>
          <td mat-cell *matCellDef="let row">{{ row.message }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="this.errorColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: this.errorColumns"></tr>
      </table>
    </div>
  }

  @if (this.importResult && !this.isRejected) {
    <div class="result" aria-live="polite">
      <h3 class="result-title">インポート結果</h3>
      <ul class="result-list">
        <li>連携対象に登録したユーザー: {{ this.importResult.imported }} 人</li>
        <li>
          メールアドレス未入力のためスキップ:
          {{ this.importResult.skippedNoEmail }} 件
        </li>
        <li>
          AI Sales Coach に未登録のためスキップ:
          {{ this.importResult.skippedUnregistered }} 件
        </li>
        <li>
          置換前の連携対象ユーザー:
          {{ this.importResult.deletedMappingCount }} 人
        </li>
      </ul>
    </div>
  }

  <h2 class="section-title">現在の連携対象ユーザー</h2>
  <app-loading [showLoading]="this.isLoading"></app-loading>

  @if (!this.isLoading) {
    <div>
      @if (this.mappings.length === 0) {
        <p class="empty">連携対象ユーザーは登録されていません。</p>
      }
      @if (this.mappings.length > 0) {
        <table mat-table [dataSource]="this.mappings" class="mapping-table">
          <ng-container matColumnDef="biztelAccountId">
            <th mat-header-cell *matHeaderCellDef>アカウントID</th>
            <td mat-cell *matCellDef="let row">
              {{ row.biztelAccountId }}
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>ユーザー名</th>
            <td mat-cell *matCellDef="let row">{{ row.user.name }}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>メールアドレス</th>
            <td mat-cell *matCellDef="let row">{{ row.user.email }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="this.mappingColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: this.mappingColumns"></tr>
        </table>
      }
    </div>
  }
</section>
